// src/components/Footer.js
import React from 'react';

const Footer = () => {
  return (
    <footer className="text-center bg-dark text-white py-4">
      <p>� 2024 DealPoint. All rights reserved.</p>
    </footer>
  );
};

export default Footer;

